import { useParams } from "react-router-dom";
import { useQuery } from '@tanstack/react-query';
import { Paper } from "@mantine/core";
import RequestBody from "../components/RequestBody";

interface RequestProps {
  onClose: Function;
}

export default function Request({ onClose }: RequestProps) {
  const { requestType, requestId } = useParams();
  const query = useQuery({
    queryKey: [requestType, requestId],
    queryFn: () => fetch(`/${requestType}/${requestId}.json`)
      .then(r => r.json())
  });

  return (
    <Paper p="xl" bg="gray.1">
      {query.isPending ?
        'Loading...' :
        <RequestBody request={query.data} onClose={onClose} />
      }
    </Paper>
  );
}
